import { Controller } from "react-hook-form";
import FieldBlock from "./FieldBlock";
import FieldError from "./FieldError";
import FieldHint from "./FieldHint";
import FieldLabel from "./FieldLabel";
import RadioGroup from "./RadioGroup";
import { getVisibleFieldErrorMessage } from "../preActivationVisibleErrors";

const RadioFieldBlock = ({
  name,
  label,
  hint,
  required = false,
  options = [],
  control,
  readOnly,
}) => (
  <FieldBlock>
    <FieldLabel htmlFor={name} text={label} required={required} />
    {hint ? <FieldHint text={hint} /> : null}
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState, formState }) => (
        <>
          <RadioGroup
            name={name}
            options={options}
            selectedValue={field.value}
            onChange={field.onChange}
            readOnly={readOnly}
          />
          <FieldError
            message={getVisibleFieldErrorMessage(fieldState, formState)}
          />
        </>
      )}
    />
  </FieldBlock>
);

export default RadioFieldBlock;
